<template>
	<div>
		<div class="task_box_case"  v-for="(item , idx ) in updatedList" :key="'eHistory_'+idx" >
			<div class="left" v-if="item.length != 0">
					<!-- {{ statusHistory[0].paperStatus == 'GOOD' && statusHistory[0].endDay > todayDate  ? 'At_risk': ''}}
					{{ statusHistory[0].paperStatus == "PAUSE" && statusHistory[0].endDay > todayDate  ? 'At_risk': ''}}
					{{ statusHistory[0].paperStatus == "ING" && statusHistory[0].endDay > todayDate  ? 'On_Track': ''}}
					{{ statusHistory[0].paperStatus == "COMPL" ? 'Exceeded': statusHistory[0].endDay &lt; todayDate ? 'Off_Track': ''}}	 -->
			</div>
			<div class="right" >
				<div class="info">
					<div :class="getEvaluateClassAndText(item).evaluateClass"></div> 
					<div  v-if="item.workItem == 'CREATED'" class="status created">{{item.workItem}} 
						<span>{{item.workKbnName }} {{item.workItemName}}</span></div>
					<div  v-if="item.workItem != 'CREATED' " class="status updated">UPDATE
						<span>{{item.workKbnName}} {{item.workItemName}}</span></div> 		
				</div>
				<div class="step_name" ><span class="cursor" @click="goProjectListTab(item)">{{item.categoryName}}</span></div>
				<div class="tit" ><span class="cursor" @click.stop="goBoard(item)">{{ item.paperTitle }}</span></div>
				<div class="info btm">
					<div class="date">
						<template v-if="item.historyDay == $moment().format('YYYY-MM-DD')">
							<momentAgo prefix="" suffix="전" :date="item.historyDate" lang="kr"></momentAgo>
							<span class="ico-new" v-if="item.readCount == null || item.readCount == 0"></span>
						</template>
						<template v-if="item.historyDay != $moment().format('YYYY-MM-DD')">
							{{ $moment(item.historyDate).format('YYYY.MM.DD') }}
							<span class="ico-new" v-if="item.readCount == null || item.readCount == 0"></span>
						</template>
					</div> 
					<div class="member">
						<div class="droplayer tooltipmember">
							<v-menu offset-y>
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on">
										<b>{{defaultLanguage.indexOf('ko') != -1 ? item.regUserName : item.regUserNameEn != null ? item.regUserNameEn : item.regUserName}}</b>
									</v-btn>
								</template>
								<div class="dropdown-list">
									<UserTooltip
										:userId="item.regUserId"
									/>
								</div>
							</v-menu>
						</div>
					</div> 
					<div class="linked" style="cursor: pointer;"
						@click="moveProject(item.linkProjectId)" v-if="item.linkProjectName != null">Linked : {{item.linkProjectName}}</div>
				</div> 
				<HistoryDetail 
					:paperId="item.paperId" 
					:groupId="groupId"
					:item="item" 
				></HistoryDetail>  
			</div>
		</div> 
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex"; 
import EventBus from "@/js/eventbus/eventBus";
import axios from "axios";
import Vue from "vue";
import HistoryDetail from "./HistoryDetail";

import UserTooltip from "@/components/cowork/common/user/UserTooltip";
export default { 
	components:{
		HistoryDetail,
		UserTooltip
	},
	props: [
		'updatedList',
		'groupId',
		'isSnapshot'
	],
	 data() {
        return {
			defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
		};
	},
	computed: {},
	watch:{},
	mounted(){},
	methods: {
		...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]), 
		checkHours(lastUpdated) {
			let now = this.$moment()
			let before24hours = this.$moment().subtract(1,'days')
			let lastUpdatedTime = this.$moment(lastUpdated)
			
			if(lastUpdatedTime.isBetween(before24hours, now)) {
				// 24시간 이내
				return true;
			}else{
				// 24시간 이후
				return false;
			}
		},
		moveProject(linkProjectId){ 
			if(this.isSnapshot) {
				return;
			}
			let path = "/general/dashboard/" + linkProjectId;
			this.$router.push(path);
		},
		getByteLength(str) {
            if (str == null || str.length == 0) {
                return 0;
            }
            var size = 0;
            for ( var i = 0; i < str.length; i++) {
                size += this.charByteSize(str.charAt(i));
            }
            return size;
        },
        cutByteLength(s, len) {
            if (s == null || s.length == 0) {
                return 0;
            }
            var size = 0;
            var rIndex = s.length;
            for ( var i = 0; i < s.length; i++) {
                size += this.charByteSize(s.charAt(i));
                if( size == len ) {
                    rIndex = i + 1;
                    break;
                } else if( size > len ) {
                    rIndex = i;
                    break;
                }
            }
            return s.substring(0, rIndex);
        },
        charByteSize(ch) {
            if (ch == null || ch.length == 0) {
                return 0;
            }
            var charCode = ch.charCodeAt(0);

            if (charCode <= 0x00007F) {
                return 1;
            } else if (charCode <= 0x0007FF) {
                return 2;
            } else if (charCode <= 0x00FFFF) {
                return 2;
            } else {
                return 2;
            }
        },
        checkTextLength(data){
          let dataLength = this.getByteLength(data); 
          if(dataLength > 60){
            let cutString = this.cutByteLength(data,60); 
            return cutString+"..."; 
          }else{
            return data;
          }
		},
		getEvaluateClassAndText(board){
			let rtnEvaluateJson = {evaluateClass: '', evaluateText: ''};
			// exceeded
			if(board.paperStatus == 'GOOD') {
				rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-good";
				rtnEvaluateJson.evaluateText = "Exceeded";
			}
			// on track
			else if(board.paperStatus == 'SO') {
				rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-so";
				rtnEvaluateJson.evaluateText = "On-Track";
			}
			// at risk
			else if(board.paperStatus == 'DELAY') {
				rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-delay";
				rtnEvaluateJson.evaluateText = "At-Risk";
			}
			// off track
			else if(board.paperStatus == 'EXCEEDED') {
				rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-exceeded";
				rtnEvaluateJson.evaluateText = "Off-Track";
			}
			return rtnEvaluateJson;
		},
		goProjectListTab(item) {
			if(this.isSnapshot) {
				return;
			}
			EventBus.$emit("goProjectListTab", item);
		},
		goBoard(item) {
			window.sessionStorage.setItem("moveBoard",true); 
			if(this.isSnapshot) {
				let postPath = item.paperProjectLinkId == null ? (item.paperId) : (item.paperId+"/"+item.paperProjectLinkId);
				let path = "/general/board/" + postPath; 
				window.open(path);
			} else {
				let postPath = item.paperProjectLinkId == null ? (item.paperId) : (item.paperId+"/"+item.paperProjectLinkId);
				let path = "/general/board/" + postPath; 
				this.$router.push(path);
			}
			
		}
	}
}
</script>

<style scoped>
.history .task_box_case .right > .tit { 
	cursor: auto;
}

.cursor { 
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/project/detail/tab/history/HistoryData.vue